export const bfacmColors = {
  primaryBackground: '#121220',
  onImageBackground: '#FFFFFF',
  onIconsAndTextButtons: '#FFFFFF',
  onIconsAndTextButtonsVariant: '#FFFFFF',
  secondaryBackground: '#252530',
  selectedAndDetailBackground: '#383849',
  borderLine: '#383849',
  placeholderText: '#6A6A81',
  menuBackground: '#17174b',
  currentStep: '#EC6907',
  onSecondaryAndDetailBackground: '#FFFFFF',
  hoverMenuBackground: '#3b3b72',
  mainFocused: '#ec6907',
  highlight: '#ec6907',
  tradingDown: '#ec6907',
  tradingUp: '#ec6907',
  off: '#4b4b61',
  lower: '#8a8d8e',
  footerBackground: '#23232d',
  onFooterBackground: '#FFFFFF',
  popupWindow: '#8a8d8e',
  popupWindowTitle: '#FFFFFF',
  iconsOnFooterBackground: '#ec6907',
  primaryDisabledBackground: '#25253b',
  secondaryDisabledBackground: '#151524',
  primaryDisabledText: '#404053',
  secondaryDisabledText: '#4B4B5F',
  scrollOnDetailBackground: '#1e1e2f',
  scrollOnPrimaryBackground: '#323249',
  infoBackground: '#2e2e3e',
  nextStep: '#4b4a4a',
  previousStep: '#393939',
  iconsOnMenuBackground: '#9090a9',
  mainFocusedSoothing: '#3c4466',
  highlightSoothing: '#534942',
  pillBorder: '#6c6cb8',
  pillBackgroundGloomy: '#9d9ddd',
  pillBackgroundLight: '#21213c',
  dividerOnPrimaryBackground: '#2d2d45',
  label: '#606073',
  homePageBackground: '#121220',
  onHomePageBackground: '#ffffff',
  refreshButton: '#2e2e3e',
  dashboardDivider: '#4b4b61',
  star: '#FFB215',
  up: '#1BCA40',
  down: '#ff0000',
  inert: '#929291',
  scrollOnInfoBackground: '#151524',
  actionBar: '#202035',
  onInfoBackground: '#FFFFFF',
  onPrimaryBackground: '#FFFFFF',
  lockedBackground: 'rgba(38, 38, 70, 0.65)',
  hoverHighlight: '#ff7d1c',
  variantOnInfoBackground: '#FFFFFF',
  variantOnPrimaryBackground: '#8a8d8e',
  graphBackground: '#1b1b2b',
  disabledAndHoverOnInfoBackground: '#474756',
  disabledOnPrimaryBackground: '#363b47',
  iconsSelectedOnMenu: '#FFFFFF',
  selectedBarOnMenu: '#FFFFFF',
  selectedTextButtonMenu: '#ec6907',
  newsBackground: '#212130',
};
